import {CONFIG} from 'config/config';

export class SocialNetworkIdResolver {
    constructor() {
        /** @private */
        this._appIds = CONFIG.APP_ID;
    }

    createPayload(serviceName, accessToken, idToken, forwardReferer, newsletter, firstName=null, lastName=null) {
        const data = {
            sn_id: this._appId(serviceName),
            id_token: idToken,
            sn_access_token: accessToken,
            forwarded_referer: (forwardReferer && window.document.referrer) ? window.document.referrer : null,
            newsletter,
            first_name: firstName,
            last_name: lastName
        };

        const queryParams = {
            params: {
                sn: serviceName,
            },
        };

        return {data, queryParams};
    }

    /** @private */
    _appId(serviceName) {
        switch (serviceName) {
        case 'facebook':
            return this._appIds.FACEBOOK;
        case 'google':
            return this._appIds.GOOGLE;
        case 'apple':
            return this._appIds.APPLE;
        default:
            throw new Error(`Specified provider is not supported ${serviceName}`);
        }
    }
}